module.exports = __webpack_public_path__ + "static/media/cycle.f9a5d169.svg";